export const REG_FUNNEL_BLOCK_ONE = 1;
export const REG_FUNNEL_BLOCK_TWO = 2;
export const REG_FUNNEL_BLOCK_THREE = 3;
export const REQUIRED_WIZARD_BLOCK = "1";
export const JOIN_REASON_CRITERIA = "join_reasons";
export const AGE_CRITERIA = "age";
export const HAS_CHILDREN_CRITERIA = "has_children";
export const MORE_CHILDREN_CRITERIA = "more_children";
export const HEIGHT_CRITERIA = "height";
export const WEIGHT_CRITERIA = "weight";
export const BODY_TYPE_CRITERIA = "body_type";
export const DRINK_CRITERIA = "drink";
export const SMOKE_CRITERIA = "smoke";
export const LOCATION_CRITERIA = "location";
export const BIRTHDAY_CRITERIA = "birthday";
export const MARITAL_STATUS_CRITERIA = "marital_status";
export const CHILDREN_CRITERIA = "children";
export const EDUCATION_CRITERIA = "education_level";
export const RELIGION_CRITERIA = "religion";
export const OCCUPATION_CRITERIA = "occupation";
export const BIO_CRITERIA = "bio";
export const SAFE_MODE_WIZARD = 1;
export const DEFAULT_MODE_WIZARD = 0;
